import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';

const Filters = ({
  type = 'movies',
  onGenreChange,
  onLanguageChange,
  onYearChange,
  onSortChange,
  onProviderChange,
  onSearch,
  genreValue,
  languageValue,
  yearValue,
  sortValue,
  providerValue,
  lang,
  translations
}) => {
  // Local state for temporary filter values
  const [tempFilters, setTempFilters] = useState({
    genre: genreValue,
    language: languageValue,
    year: yearValue,
    sort: sortValue,
    provider: providerValue || ''
  });

  const t = (key) => {
    const langData = translations[lang] || translations.en;
    return langData[key] || key;
  };

  const tNested = (objKey, key) => {
    const langData = translations[lang] || translations.en;
    const obj = langData[objKey];
    return obj ? obj[key] : key;
  };

  useEffect(() => {
    setTempFilters({
      genre: genreValue,
      language: languageValue,
      year: yearValue,
      sort: sortValue,
      provider: providerValue || ''
    });
  }, [genreValue, languageValue, yearValue, sortValue, providerValue]);

  const handleFilterChange = (filterType, value) => {
    setTempFilters(prev => ({
      ...prev,
      [filterType]: value
    }));
  };

  const handleSearchClick = () => {
    onGenreChange(tempFilters.genre);
    onLanguageChange(tempFilters.language);
    onYearChange(tempFilters.year);
    onSortChange(tempFilters.sort);
    if (onProviderChange) onProviderChange(tempFilters.provider);
    onSearch();
  };

  const genreObj = type === 'movies' ? 'movieGenres' : 'seriesGenres';
  const sortObj = type === 'movies' ? 'movieSortOptions' : 'seriesSortOptions';
  const yearLabel = type === 'movies' ? 'releaseYear' : 'firstAirYear';

  const sortOptionsWithEmptyFirst = (obj) => {
    const keys = Object.keys(obj);
    keys.sort((a, b) => {
      if (a === '') return -1;
      if (b === '') return 1;
      return 0;
    });
    return keys.map(key => ({
      value: key,
      text: obj[key] || key
    }));
  };

  const filtersConfig = [
    {
      id: type === 'movies' ? 'genreSelect' : 'seriesGenreSelect',
      label: t('genre'),
      value: tempFilters.genre,
      filterType: 'genre',
      options: sortOptionsWithEmptyFirst(translations[lang][genreObj] || {}),
    },
    {
      id: type === 'movies' ? 'languageSelect' : 'seriesLanguageSelect',
      label: t('language'),
      value: tempFilters.language,
      filterType: 'language',
      options: sortOptionsWithEmptyFirst(translations[lang].languages || {}),
    },
    {
      id: type === 'movies' ? 'yearSelect' : 'seriesYearSelect',
      label: t(yearLabel),
      value: tempFilters.year,
      filterType: 'year',
      options: sortOptionsWithEmptyFirst(translations[lang].years || {}),
    },
    {
      id: type === 'movies' ? 'sortSelect' : 'seriesSortSelect',
      label: t('sortBy'),
      value: tempFilters.sort,
      filterType: 'sort',
      options: sortOptionsWithEmptyFirst(translations[lang][sortObj] || {}),
    },
  ];

  // ===== ADD PROVIDER FILTER (for both movies and series) =====
  // Insert after sort (position 4) for consistency
  filtersConfig.splice(4, 0, {
    id: type === 'movies' ? 'providerSelect' : 'seriesProviderSelect',
    label: t('provider'),
    value: tempFilters.provider,
    filterType: 'provider',
    options: sortOptionsWithEmptyFirst(translations[lang].providers || {}),
  });

  return (
    <>
      <div className="filters-container">
        {filtersConfig.map(filter => (
          <div key={filter.id} className="filter-group">
            <label className="filter-label" htmlFor={filter.id}>
              {filter.label}
            </label>
            <select
              id={filter.id}
              className="filter-select"
              value={filter.value}
              onChange={(e) => handleFilterChange(filter.filterType, e.target.value)}
            >
              {filter.options.map(option => (
                <option key={option.value} value={option.value}>
                  {option.text}
                </option>
              ))}
            </select>
          </div>
        ))}
        
        <div className="search-btn-container">
          <button 
            className="search-movies-btn"
            onClick={handleSearchClick}
          >
            <FontAwesomeIcon icon={faSearch} />
            {type === 'movies' ? t('searchMovies') : t('searchSeries')}
          </button>
        </div>
      </div>
    </>
  );
};

export default Filters;